import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { ASSETS } from "@/lib/site";
import { setSeo } from "@/lib/seo";

export default function AdminLogin() {
  const { admin, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    setSeo({ title: "Admin login | Blue Shuck Consulting LTD" });
  }, []);

  useEffect(() => {
    if (admin) navigate("/admin", { replace: true });
  }, [admin, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const res = await login(email.trim(), password);
    setSubmitting(false);
    if (res.ok) navigate("/admin", { replace: true });
    else setError(res.error);
  };

  const inputClass =
    "w-full rounded-lg border border-slate-200 bg-white px-4 py-3 text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-brand-blue/40 focus:border-brand-blue transition";

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-6">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center">
          <img src={ASSETS.wolfNavy} alt="Blue Shuck" className="h-14 w-14 object-contain" />
          <h1 className="mt-4 font-heading font-700 text-2xl text-brand-navy">
            Admin sign in
          </h1>
          <p className="mt-1 text-sm text-slate-500">Blue Shuck Consulting LTD</p>
        </div>

        <form
          data-testid="admin-login-form"
          onSubmit={handleSubmit}
          className="mt-8 rounded-2xl border border-slate-200 bg-white p-8 shadow-sm"
        >
          {error && (
            <div
              data-testid="admin-login-error"
              className="mb-4 rounded-lg bg-red-50 border border-red-200 px-4 py-3 text-sm text-red-700"
            >
              {error}
            </div>
          )}
          <label className="block text-sm font-medium text-slate-700 mb-1.5">
            Email
          </label>
          <input
            data-testid="admin-login-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={inputClass}
            placeholder="you@company.com"
            required
          />
          <label className="block text-sm font-medium text-slate-700 mb-1.5 mt-4">
            Password
          </label>
          <input
            data-testid="admin-login-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={inputClass}
            placeholder="••••••••"
            required
          />
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={submitting}
            className="mt-6 w-full inline-flex items-center justify-center gap-2 bg-brand-navy text-white font-medium px-6 py-3 rounded-lg hover:bg-brand-navy-dark transition-colors disabled:opacity-60"
          >
            {submitting ? (
              <Loader2 className="h-5 w-5 animate-spin" />
            ) : (
              <>
                <Lock className="h-4 w-4" />
                Sign in
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
